import React from 'react'
import Johns from './experience/johns'
import Flatiron from './experience/flatiron'
//hook for checking if an el is in viewport
import useIsInViewport from 'use-is-in-viewport'

function Experience() {
	const [isInViewport, targetRef] = useIsInViewport()
	var classes = `${isInViewport ? "visible" : "hidden"}`
	return ( 
		<div ref={targetRef} className={classes}>
			<div className="Experience" id="experience">
				<h2>Experience</h2>
				<Johns/>
				<br/>
				<Flatiron/>
			</div>
		</div>
	  )
}

export default Experience
